import { apiService } from '../../../shared/services/apiService';
import { downloadBinaryFile } from '../../../shared/utils/apiUtils';
import {
  CustomerInbodyTypeOption,
  GetInbodyIndicatorsResponse,
  ScanService,
  UpdateScansFromInbodyResponse,
  DownloadInbodyResultSheetParams,
  ProgressReportParams,
  ProgressReportUrlResponse,
  RequestConfig,
} from './types';
import { apiStatusStore } from '../../../shared/stores/apiStatusStore';
import { ManualScanData } from '../../interfaces/customerInbodyData';
import { InbodyType } from '../../../shared/constants/inbody-info/InbodyType';
import { ScanMetadata } from '../../interfaces/scanMetadata';
import { KeyBodyMetricsInfo } from '../../interfaces/keyBodyMetricsInfo';

export const scanIqScanService: ScanService = {
  async getInbodyIndicators(
    customerId: number,
    userInbodyType: InbodyType | 'ALL',
    entityId: number,
  ) {
    const resp = await apiService.post<GetInbodyIndicatorsResponse>(
      `/api/scan-iq/customers/${customerId}/inbody-data`,
      { userInbodyType },
      // allFields: return every indicator (false would drop indicators not supported by the inbody type);
      { params: { entityId, allFields: true } },
    );
    return resp.data;
  },

  async getCustomerInbodyTypeOptions(customerId: number, entityId: number) {
    const resp = await apiService.get<CustomerInbodyTypeOption[]>(
      `api/scan-iq/customers/${customerId}/inbody-types`,
      { params: { entityId } },
    );
    return resp.data;
  },

  async getScanDates(customerId: number, entityId: number, config?: RequestConfig) {
    const resp = await apiService.get<ScanMetadata[]>(
      `api/scan-iq/customers/${customerId}/scan-dates`,
      { params: { entityId }, ...config },
    );
    return resp.data;
  },

  async getKeyBodyMetrics(customerId: number, entityId: number) {
    const resp = await apiService.get<KeyBodyMetricsInfo>(
      `api/coach/scan-iq/customers/${customerId}/stats/body-metrics`,
      { params: { entityId } },
    );
    return resp.data;
  },

  async downloadInbodyResultSheet({
    customerId,
    scanId,
    fileName,
    entityId,
  }: DownloadInbodyResultSheetParams) {
    const resp = await apiService.get<ArrayBuffer>(
      `/api/entity/${entityId}/scan-iq/${customerId}/inbody-data/${scanId}/result-sheet`,
      { responseType: 'arraybuffer' },
    );

    downloadBinaryFile(resp.data, 'image/png', `${fileName}.png`);
  },

  async updateScansFromInbody(customerId: number, entityId?: number) {
    const resp = await apiService.put<UpdateScansFromInbodyResponse>(
      `/api/scan-iq/customers/${customerId}/inbody/scan/upload`,
      undefined,
      { params: { entityId } },
    );

    return resp.data;
  },

  async getProgressReportUrl(customerId: number, params: ProgressReportParams) {
    const resp = await apiService.post<ProgressReportUrlResponse>(
      `/api/scan-iq/customers/${customerId}/progress-report`,
      params,
    );

    return resp.data;
  },

  // Unavailable APIs - throw Error and show message
  async getMealPlansOnScanDay(customerId: number) {
    const errorMessage = `Meal plans are not available for SCAN_IQ customers ${customerId}`;
    apiStatusStore.addErrorMessage(errorMessage);
    throw new Error(errorMessage);
  },

  async getScanDataByInbodyId(inbodyId: number | string) {
    const errorMessage = `Inbody device data is not available for SCAN_IQ customers ${inbodyId}`;
    apiStatusStore.addErrorMessage(errorMessage);
    throw new Error(errorMessage);
  },

  async createScanManually(customerId: number, scanDate: ManualScanData) {
    const errorMessage = `Manual scan creation is not available for SCAN_IQ customers ${customerId} ${scanDate}`;
    apiStatusStore.addErrorMessage(errorMessage);
    throw new Error(errorMessage);
  },
};
